"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    A: { en: 'General and unspecified', colour: 'ICPC-2--A' },
    B: {
        en: 'Blood, blood forming organs, lymphatics, spleen',
        colour: 'ICPC-2--B',
    },
    D: { en: 'Digestive', colour: 'ICPC-2--D' },
    F: { en: 'Eye', colour: 'ICPC-2--F' },
    H: { en: 'Ear', colour: 'ICPC-2--H' },
    K: { en: 'Circulatory', colour: 'ICPC-2--K' },
    L: { en: 'Musculoskeletal', colour: 'ICPC-2--L' },
    N: { en: 'Neurological', colour: 'ICPC-2--N' },
    P: { en: 'Psychological', colour: 'ICPC-2--P' },
    R: { en: 'Respiratory', colour: 'ICPC-2--R' },
    S: { en: 'Skin', colour: 'ICPC-2--S' },
    T: { en: 'Endocrine, metabolic and nutritional', colour: 'ICPC-2--T' },
    U: { en: 'Urology', colour: 'ICPC-2--U' },
    W: { en: 'Pregnancy, childbirth, family planning', colour: 'ICPC-2--W' },
    X: { en: 'Female genital system and breast', colour: 'ICPC-2--X' },
    Y: { en: 'Male genital system', colour: 'ICPC-2--Y' },
    Z: { en: 'Social problems', colour: 'ICPC-2--Z' },
};
//# sourceMappingURL=icpc2.js.map